import React from 'react';
import PropTypes from 'prop-types';

// Wraps CheckBoxPopups and MultipleChoicePopups
export default class SelfServeGroupPopup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderWithData = this.renderWithData.bind(this);
    this.renderInactive = this.renderInactive.bind(this);
  }

  renderWithData() {
    const { isMultipleChoice } = this.props;
    const alt = isMultipleChoice ? 'Multiple Choice' : 'Checkbox';
    // Renders the `checkbox_tick` image for both checkbox and multiple choice
    return (
      <img
        alt={alt}
        src="/free-write/assets/img/checkbox_tick.png"
        style={{
          width: this.props.width,
          height: this.props.height,
        }}
        className="self-serve-recipient-group-popup"
      />
    );
  }

  renderInactive() {
    return (
      <div
        className="inactive-self-serve-popup-img"
        style={{
          width: this.props.width,
          height: this.props.height,
        }}
      />
    );
  }

  render() {
    if (this.props.isCurrentItemSelected && this.props.isPreviewMode) {
      return this.renderWithData();
    }
    if (this.props.isAnyItemSelected && this.props.isPreviewMode) {
      return null;
    }
    if (!this.props.isActiveGroup) {
      return this.renderInactive();
    }
    return (
      <React.Fragment>
        { this.props.children }
      </React.Fragment>
    );
  }
}

SelfServeGroupPopup.defaultProps = {
  isActiveGroup: false,
  isActivePopup: false,
  isAnyItemSelected: false,
  isCurrentItemSelected: false,
  isMultipleChoice: false,
  isPreviewMode: false,
};

SelfServeGroupPopup.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.number.isRequired,
  isActiveGroup: PropTypes.bool,
  isAnyItemSelected: PropTypes.bool,
  isPreviewMode: PropTypes.bool,
  isMultipleChoice: PropTypes.bool,
  isCurrentItemSelected: PropTypes.bool,
  width: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/Popups/SelfServeBuilderPopups/SelfServeGroupPopup.jsx